export default "__VITE_ASSET__DQOUefhP__"